import React, { Component } from 'react';
//import './kanban.css'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ProjectSelect from '../Projects/ProjectSelect'
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import authStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';
import UserSelect from '../Users/UserSelect';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import IconButton from '@mui/material/IconButton';
import { observer } from 'mobx-react';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import ServerStore from './ServerStore';
import ServerTable from './ServerTable';

const ServersBoard = observer(class ServersBoard extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            servers: [],
            searchStr: '',
            filterProjectId: (localStorage.getItem('filterServerProjectId') !== 'null' && !!localStorage.getItem('filterServerProjectId')) ? localStorage.getItem('filterServerProjectId') : '',
            filterProjectName: (localStorage.getItem('filterProjectName') !== 'null') ? localStorage.getItem('filterProjectName') : '',
            filterAssigneId: (localStorage.getItem('filterAssigneId') !== 'null' && !!localStorage.getItem('filterAssigneId')) ? localStorage.getItem('filterAssigneId') : '',
            filterAssigneeName: (localStorage.getItem('filterAssigneeName') !== 'null' && !!localStorage.getItem('filterAssigneeName')) ? localStorage.getItem('filterAssigneeName') : '',
        });

        this.columns = [
            { field: 'caption', title: 'Имя', width: 150 },
            { field: 'address', title: 'Адрес', width: 150 },
            { field: 'typeName', title: 'Тип', width: 150, defaultGroupOrder: 1 },
            { field: 'categoryName', title: 'Категория', width: 150 },
            { field: 'accountName', title: 'Контрагент', width: 150, defaultGroupOrder: 0 },
            { field: 'ownerName', title: 'Ответственный', width: 150 },
            { field: 'accessProtocolName', title: 'Протокол подключения', width: 150 },
            { field: 'login', title: 'Пользователь', width: 150 },
            { field: 'password', title: 'Пароль', width: 150 },
            { field: 'projectName', title: 'Проект', width: 150 },
        ];

        this.load = this.load.bind(this);
        this.handleServerUpdate = this.handleServerUpdate.bind(this);

        ServerStore.setAutorunFunction(this.handleServerUpdate);
    }

    componentDidMount() {
        var scope = this;
        if (!authStore.isAuth) {
            authStore.openLogin(() => { scope.load(); });
            return;
        }
        else this.load();
    }

    load() {
        var scope = this;
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Server',
            null
            ,
            'application/json',
            (result) => {
                scope.setState({ servers: result });
                MainStore.setMaskUnvisible();
            },
            'GET'
        );
    }

    openEditServerDialog(rowData) {
        ServerStore.openServerDialog(rowData);
    }

    deleteServer(rowData, resolve) {
    }

    openAddServerDialog() {
        ServerStore.openServerDialog({ description: '' });
    }

    handleServerUpdate(server) {
        let servers = this.state.servers.slice(0);
        var index = servers.findIndex(s => s.id === server.id);
        if (index > -1) {
            servers.splice(index, 1, server);
        }
        else {
            servers.push(server);
        }
        this.setState({ servers: servers });
    }
   
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    render() {
        return (
            <ServerTable />
        );
    }
});

export default ServersBoard;